import { api } from '../utils/apiClient';

export interface ChaosExperimentLibraryItem {
  id: number;
  type: string;
  enabled?: boolean;
  created_at?: string;
}

export interface ChaosLibraryListResponse {
  data: ChaosExperimentLibraryItem[];
}

export interface ChaosLibraryUploadResult {
  added: number;
  skipped: number;
}

export const listChaosExperiments = (
  projectId: string
): Promise<ChaosLibraryListResponse> =>
  api.get<ChaosLibraryListResponse>(
    `/chaos/experiment-library?project_id=${projectId}`
  );

export const createChaosExperiment = (projectId: string, type: string) =>
  api.post('/chaos/experiment-library', {
    project_id: projectId,
    type,
  });

export const deleteChaosExperiment = (_projectId: string, experimentId: number) =>
  api.delete(`/chaos/experiment-library/${experimentId}`);

export const deleteChaosLibrary = (projectId: string) =>
  api.delete(`/chaos/experiment-library?project_id=${projectId}`);

export const updateChaosExperimentEnabled = (
  experimentId: number,
  enabled: boolean
) => api.put(`/chaos/experiment-library/${experimentId}/enabled`, { enabled });

export const uploadChaosLibrary = (
  projectId: string,
  records: unknown[]
): Promise<ChaosLibraryUploadResult> =>
  api.post<ChaosLibraryUploadResult>(
    `/chaos/experiment-library/upload-library?project_id=${projectId}`,
    records
  );
